module.exports = __webpack_public_path__ + "img/forbidden-light.5af1d1bf.svg";